<template>
    <div class="d-md-flex align-items-center justify-content-between mb-2 mt-2">
        <div>
            <h4 class="main-title mb-0">Circles</h4>
        </div>
    </div>
    <div class="row g-3 mb-2">
        <div class="col-xl-4">
            <form class="card card-one" @submit.prevent="submitForm()">
                <div class="card-header">
                    <h6 class="card-title" v-if="status">New Circle</h6>
                    <h6 class="card-title" v-else>Update Circle</h6>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-12 mb-2">
                            <label class="form-label">Sub Division</label><span class="text-danger"> *</span>
                            <select class="form-select" :class="{'is-invalid': errors.sub_division_id}" v-model="circle.sub_division_id" ref="sub_division_id">
                                <option value="">Select Sub Division</option>
                                <option v-for="sd, key in sub_divisions" :key="key" :value="sd.sub_division_id">{{ sd.sub_division }}</option>
                            </select>
                            <span v-if="errors.sub_division_id" class="invalid-feedback">{{ errors.sub_division_id[0] }}</span>
                        </div>
                        <div class="col-md-12">
                            <label class="form-label">Circle</label><span class="text-danger"> *</span>
                            <input type="text" class="form-control" placeholder="Circle" :class="{'is-invalid': errors.circle}" v-model="circle.circle" ref="circle_input" />
                            <span v-if="errors.circle" class="invalid-feedback">{{ errors.circle[0] }}</span>
                        </div>
                    </div>
                </div>
                <div class="card-footer text-end">
                    <button class="btn btn-danger me-2" type="button" @click="discard()"><i class="ri-prohibited-line me-1"></i>Discard</button>
                    <button class="btn btn-primary" type="submit">
                        <span v-if="status"><i class="ri-save-line me-1"></i> Submit</span>
                        <span v-else><i class="ri-save-line me-1"></i> Update</span>
                    </button>
                </div>
            </form>
        </div>
        <div class="col-xl-8">
            <div class="card card-one">
                <div class="card-header">
                    <h6 class="card-title">Circles</h6>
                </div>
                <div class="card-body">
                    <div class="form-group">
                        <input type="text" class="form-control mb-2" id="search" placeholder="Search" v-model="meta.search" @keypress.enter="search()">
                    </div>
                    <div class="table-responsive" style="overflow-y:scroll; height: 55vh;">
                        <table class="table table-striped text-nowrap table-bordered table-hover table-bottom-border mb-0">
                            <thead>
                                <tr style="background-color: #f5f5f5;">
                                    <th class="text-center">Sl No.</th>
                                    <th @click="sort('sub_division_id')">Sub Division</th>
                                    <th @click="sort('circle')">Circle</th>
                                    <th class="text-center">Status</th>
                                    <th class="text-center">Actions</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="c, key in circles" :key="key">
                                    <td class="text-center">{{ meta.from + key }}</td>
                                    <td>{{ c.sub_division?.sub_division }}</td>
                                    <td>{{ c.circle }}</td>
                                    <td class="text-center">
                                        <div class="form-switch">
                                            <input class="form-check-input" type="checkbox" role="switch" :id="'circle' + c.circle_id" :checked="c.status" @change="deleteCircle(c)" />
                                            <label class="custom-control-label" :for="'circle' + c.circle_id"></label>
                                        </div>
                                    </td>
                                    <td class="text-center">
                                        <a href="javascript:void(0)" class="text-primary me-2" @click="edit(c)"><i class="ri-edit-line fs-18 lh-1"></i></a>
                                    </td>
                                </tr>
                                <tr v-if="circles.length <= 0">
                                    <td colspan="5" style="text-align: center;">No Records Found</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card-footer">
                    <Pagination :maxPage="meta.maxPage" :totalPages="meta.lastPage" :currentPage="meta.page" @pagechanged="onPageChange" />
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import Pagination from "@/components/Pagination.vue";
export default {
    components: { Pagination },
    data() {
        return {
            meta: {
                search: "",
                order_by: "asc",
                keyword: "circle",
                per_page: 10,
                totalRows: 0,
                page: 1,
                lastPage: 1,
                from: 1,
                maxPage: 1,
            },
            status: true,
            circle: {
                circle_id: "",
                sub_division_id: "",
                circle: "",
                status: ""
            },
            circles: [],
            sub_divisions: [],
            errors: [],
        };
    },
    mounted() {
        this.getSubDivisions();
        this.index();
    },
    methods: {
        submitForm() {
            if (this.status) this.create();
            else this.update();
        },
        index() {
            let vm = this;
            vm.$store.dispatch("post", { uri: "paginateCircles", data: vm.meta })
                .then(function (response) {
                    vm.circles = response.data.data;
                    vm.meta.totalRows = response.data.meta.total;
                    vm.meta.lastPage = response.data.meta.last_page;
                    vm.meta.from = response.data.meta.from;
                    vm.meta.maxPage = vm.meta.lastPage >= 3 ? 3 : vm.meta.lastPage;
                })
                .catch(function (error) {
                    vm.errors = error.response?.data?.errors || [];
                    vm.$store.dispatch("error", error.response?.data?.message || "Error loading circles");
                });
        },
        create() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store.dispatch("post", { uri: "addCircle", data: vm.circle })
                .then(function () {
                    loader.hide();
                    vm.$store.dispatch("success", "Circle created successfully");
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response?.data?.errors || [];
                    vm.$store.dispatch("error", error.response?.data?.message || "Error creating circle");
                });
        },
        edit(c) {
            this.circle = { ...c };
            this.status = false;
            if (this.$refs.circle_input) this.$refs.circle_input.focus();
        },
        update() {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store.dispatch("post", { uri: "updateCircle", data: vm.circle })
                .then(function () {
                    loader.hide();
                    vm.$store.dispatch("success", "Circle updated successfully");
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.errors = error.response?.data?.errors || [];
                    vm.$store.dispatch("error", error.response?.data?.message || "Error updating circle");
                });
        },
        deleteCircle(c) {
            let vm = this;
            let loader = vm.$loading.show();
            vm.$store.dispatch("post", { uri: "deleteCircle", data: c })
                .then(function (response) {
                    loader.hide();
                    vm.$store.dispatch("success", response.data.message);
                    vm.discard();
                })
                .catch(function (error) {
                    loader.hide();
                    vm.$store.dispatch("error", error.response?.data?.message || "Error");
                });
        },
        getSubDivisions() {
            let vm = this;
            vm.$store.dispatch("post", { uri: "getSubDivisions" })
                .then(function (response) {
                    vm.sub_divisions = response.data.data;
                })
                .catch(function (error) {
                    vm.$store.dispatch("error", error.response?.data?.message || "Error loading sub divisions");
                });
        },
        discard() {
            this.circle = { circle_id: "", sub_division_id: "", circle: "", status: "" };
            this.errors = [];
            this.status = true;
            if (this.$refs.circle_input) this.$refs.circle_input.focus();
            this.index();
        },
        onPageChange(page) {
            this.meta.page = page;
            this.index();
        },
        search() {
            this.meta.page = 1;
            this.index();
        },
        sort(field) {
            this.meta.keyword = field;
            this.meta.order_by = this.meta.order_by === "asc" ? "desc" : "asc";
            this.index();
        },
    },
};
</script>
